import React, { useCallback, useMemo, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { ItemSearchFacetsKey } from 'hooks';
import DelimitedInput from 'ui/DelimitedInput';

import messages from './messages';

interface IProps {
  type?: ItemSearchFacetsKey;
  values?: string[];
  onChange?: (type: ItemSearchFacetsKey, values: string[]) => void;
}

interface IOption {
  label: string;
  value: ItemSearchFacetsKey;
}

const DelimitedItemInput = ({
  type = 'itemNumbers',
  values = [],
  onChange = () => null,
}: IProps) => {
  const [selectedItemType, setSelectedItemType] =
    useState<ItemSearchFacetsKey>(type);
  const { formatMessage } = useIntl();
  const options: IOption[] = useMemo(
    () => [
      { label: formatMessage(messages.itemNumberLabel), value: 'itemNumbers' },
      { label: formatMessage(messages.upcLabel), value: 'upcs' },
    ],
    [formatMessage]
  );

  const handleTypeChange = useCallback(
    (e: SelectChangeEvent<ItemSearchFacetsKey>) => {
      setSelectedItemType(e.target.value as ItemSearchFacetsKey);
    },
    []
  );

  const handleDelimitedChange = useCallback(
    (values: string[] = []) => {
      onChange(selectedItemType, values);
    },
    [onChange, selectedItemType]
  );

  return (
    <Box>
      <FormControl sx={{ width: '100%', margin: '8px 0px' }}>
        <InputLabel id='value-delimiter'>
          <FormattedMessage {...messages.valueTypeLabel} />
        </InputLabel>
        <Select
          labelId='value-delimiter'
          value={selectedItemType}
          label={formatMessage(messages.valueTypeLabel)}
          onChange={handleTypeChange}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          <FormattedMessage {...messages.valueTypeHelperText} />
        </FormHelperText>
      </FormControl>
      <DelimitedInput values={values} onValuesChange={handleDelimitedChange} />
    </Box>
  );
};

export default DelimitedItemInput;
